import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { PhoneCallIcon, ArrowLeft, Loader2, Sparkles, KeyRound, ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';

export default function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);
    console.log("Recovery Pipeline Initiated:", data);
    setTimeout(() => setIsLoading(false), 2000);
  };

  return (
    <div className="min-h-screen bg-premium-dark flex items-center justify-center p-6 relative overflow-hidden font-poppins">
      {/* Ambient Background Glows */}
      <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-premium-teal/20 rounded-full blur-[120px] animate-pulse-slow"></div>
      <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-premium-gold/10 rounded-full blur-[120px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>

      <div className="w-full max-w-lg bg-white/5 backdrop-blur-2xl rounded-[3rem] border border-white/10 shadow-2xl overflow-hidden relative z-10 animate-fade-in-up">
        <div className="p-10 lg:p-16 text-center">

          {/* Visual Icon */}
          <div className="w-20 h-20 rounded-3xl bg-premium-gold/10 flex items-center justify-center text-premium-gold mx-auto mb-8 border border-premium-gold/20 shadow-lg shadow-premium-gold/5 transform hover:rotate-6 transition-transform">
            <KeyRound size={40} />
          </div>

          <h2 className="text-4xl font-black text-white tracking-tighter mb-3">Password Reset</h2>
          <p className="text-premium-gold text-[10px] font-black uppercase tracking-[0.4em] mb-12">Password Reset Initiated</p>

          <div className="bg-white/5 border border-white/5 rounded-2xl p-6 mb-12 text-left">
            <div className="flex gap-4 items-start">
              <ShieldAlert className="text-premium-gold shrink-0 mt-1" size={20} />
              <p className="text-gray-400 text-sm font-medium leading-relaxed">
                Enter your registered phone number below. Our system will send you a <span className="text-white font-bold">One-Time Password (OTP)</span> to verify your membership.
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
            <div className="space-y-2 text-left">
              <label className="text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] ml-1">Phone Number</label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none text-gray-500 group-focus-within:text-premium-gold transition-colors">
                  <PhoneCallIcon size={18} />
                </div>
                <input
                  placeholder='+255 XXX XXX XXX'
                  type="tel"
                  {...register("phone", {
                    required: "Communication line is required",
                    pattern: {
                      value: /^[0-9+]{10,15}$/,
                      message: "Invalid protocol format",
                    },
                  })}
                  className="w-full bg-white/5 border border-white/10 rounded-2xl py-5 pl-14 pr-6 text-white font-black text-sm focus:outline-none focus:ring-2 focus:ring-premium-gold/30 focus:border-premium-gold/50 transition-all placeholder:text-gray-600 tracking-widest"
                />
              </div>
              {errors.phone && (
                <p className="text-red-500 text-[10px] font-black uppercase tracking-widest mt-2 ml-1 animate-shake">
                  {errors.phone.message}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="premium-button w-full bg-premium-teal text-white py-5 rounded-2xl font-black text-xs uppercase tracking-[0.3em] flex items-center justify-center gap-3 shadow-2xl shadow-premium-teal/30 group disabled:opacity-70 transition-all"
            >
              {isLoading ? (
                <Loader2 className="animate-spin" size={20} />
              ) : (
                <>
                  Request OTP
                  <Sparkles size={18} className="text-premium-gold group-hover:rotate-12 transition-transform" />
                </>
              )}
            </button>
          </form>

          <div className="mt-12 pt-8 border-t border-white/5">
            <Link to="/login" className="inline-flex items-center gap-2 text-gray-500 hover:text-white transition-colors group">
              <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
              <span className="text-[10px] font-black uppercase tracking-[0.2em]">Return to Home</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Brand */}
      <div className="absolute bottom-10 left-0 w-full text-center">
        <span className="text-[10px] font-bold text-gray-600 uppercase tracking-[0.5em]">Saccoss Elite | Quantum Security v4.2</span>
      </div>
    </div>
  )
}
